import { useEffect, useRef } from "react";

const ClientTypePopUp = (props) => {
  const popupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const options = ["All Types", "Buyer", "Seller"];

  return (
    props.visible && (
      <div
        ref={popupref}
        className="w-[250px] bg-white border border-gray-300 rounded-md p-[10px] absolute z-10 top-[50px] left-0"
        style={props.style}
      >
        <div className="w-full max-h-[120px] overflow-y-scroll">
          {options.map((item, index) => (
            <div
              key={index}
              onClick={() => props.onClickcorrect(item)}
              className="py-[5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor px-[10px] rounded-xl"
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default ClientTypePopUp;
